import {useAppStore} from '../appStore'

export const userSelectors = {
  useCurrentUser: () => useAppStore(s => s.currentUser),
  useSelectedLanguage: () => useAppStore(s => s.selectedLanguage),
  useProductSwitcher: () => useAppStore(s => s.productSwitcher),
  useAccountDetails: () => useAppStore(s => s.accountDetails),
  useProductSwitcherWorkforcePermission: () =>
    useAppStore(s => s.productSwitcherWorkforcePermission),
  useProductSwitcherEmpowerPermission: () =>
    useAppStore(s => s.productSwitcherEmpowerPermission),
  useWorkforces: () => useAppStore(s => s.workforces),
  useSelectedWorkforceName: () => useAppStore(s => s.selectedWorkforceName),
  useSelectedWorkforce: () => useAppStore(s => s.selectedWorkforce),
  useEmailDisabled: () => useAppStore(s => s.emailDisabled),
  usePrevPath: () => useAppStore(s => s.prevPath),
  usePanelTheme: () => useAppStore(s => s.panelTheme),
  useIsRedirectingToLogin: () => useAppStore(s => s.isRedirectingToLogin),
} as const
